module.exports = new __parcel__URL__("lv_text.87873d27.png").toString();